<!-- Zweck: Stellt die HTML-Struktur für shop merkliste table component im Frontend bereit. -->
@if (!(msvc.isMobile()|async)) {
  @if (label) {
    <tr class="table_sectiontitle">
      <td colspan="10">
        {{label}}
      </td>
    </tr>
  }
  <tr class="thead">
    @if (showSelect) {
      <th></th>
    }
    <th>#</th>
    <th>
      <view-field-label-render [mode]="'table'" fieldname="bezeichnung"></view-field-label-render>
    </th>
    <th>Kategorie</th>
    <th>
      <view-field-label-render [mode]="'table'" fieldname="pzn"></view-field-label-render>
    </th>
    <th>
      <view-field-label-render [mode]="'table'" fieldname="darreichungsform"></view-field-label-render>
    </th>
    <th>
      <view-field-label-render [mode]="'table'" fieldname="rezeptzeichen"></view-field-label-render>
    </th>
    <th>
      <view-field-label-render [mode]="'table'" fieldname="istarzneimittel"></view-field-label-render>
    </th>
    <th>Einzelpreis</th>
    <th></th>
    <th style="width: 20px"></th>
  </tr>
  @if (poscount <= 0) {
    <tr class="hover2">
      <td [attr.colspan]="showSelect ? 12 : 11" style="text-align: center; background-color: white; padding-top: 40px">
        <div style="vertical-align: middle">
          <svg-icon style="width: 100px; height: 100px; font-size: 100px">traurig</svg-icon>
          <br>
            <div style="height: 100px; font-size: 16px; font-weight: bold">
              @if (poscount == -1) {
                Lade die Merkliste...
                <div style="text-align: center">
                  <div style="display: inline-block; width: 20px; height: 20px">
                    <mat-spinner [diameter]="20"></mat-spinner>
                  </div>
                </div>
              } @else {
                Die Merkliste ist leer.
              }
            </div>
          </div>
        </td>
      </tr>
    }
    @for (e of positions; track e; let i = $index) {
      <tr class="thead hover2">
        @if (showSelect) {
          <td>
            <mat-checkbox [(ngModel)]="selectedEntryIds[e.id]" (change)="selectionChanged()"></mat-checkbox>
          </td>
        }
        <td>
          {{i + 1}}
        </td>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="bezeichnung"></view-field-value-render>
        </td>
        <td>
          {{parent.getViewLabelBySlug(e.view_slug)}}
        </td>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'" fieldname="pzn"></view-field-value-render>
        </td>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="darreichungsform"></view-field-value-render>
        </td>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="rezeptzeichen"></view-field-value-render>
        </td>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="istarzneimittel"></view-field-value-render>
        </td>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="einkaufspreis"></view-field-value-render>
        </td>
        <td>
          <nice-number-input label="Menge" [(value)]="positions[i].menge" [disabled]="e.defect"></nice-number-input>
          <div style="display: inline-block">
            <warenkorb-button [artikel]="e.artikel" [entry]="e" [view_slug]="e.view_slug" [disabled]="e.defect"
            class="tut_merkliste_artwk"></warenkorb-button>
            <button (click)="parent.addNoteLine(e)" [disabled]="e.defect" mat-icon-button matTooltip="Notiz hinzufügen" class="tut_merkliste_artnote">
              <svg-icon>zeile-einfuegen</svg-icon>
            </button>
            <button (click)="parent.deletePosition(e)" mat-icon-button matTooltip="Position Entfernen" class="tut_merkliste_artdelete">
              <svg-icon>loeschen</svg-icon>
            </button>
            <verfuegbarkeits-info-button [artikel]="e.artikel" [entry]="e" class="tut_merkliste_artvf"
            [view_slug]="e.view_slug"></verfuegbarkeits-info-button>
          </div>
        </td>
        <td>
          <div style="width: 20px; height: 20px">
            @if (e.dirty) {
              <div matTooltip="Speichere...">
                <mat-spinner [diameter]="20"></mat-spinner>
              </div>
            }
          </div>
        </td>
      </tr>
      @for (line of e.note; track parent.trackByFn(i, line); let i = $index) {
        <tr>
          <td colspan="1">
          </td>
          <td colspan="7">
            <mat-form-field style="width: 100%">
              <input (keyup)="parent.noteAutoSave(e)" [(ngModel)]="e.note[i]" matInput maxlength="80"
                placeholder="Notiz {{i+1}}">
              <mat-hint>Maximal 80 Zeichen!</mat-hint>
            </mat-form-field>
          </td>
          <td colspan="2">
            <button (click)="parent.deleteNoteLine(e, i)" mat-icon-button matTooltip="Abbrechen">
              <svg-icon>abbrechen</svg-icon>
            </button>
          </td>
        </tr>
      }
    }
  }

  @if ((msvc.isMobile()|async)) {
    @if (label) {
      <tr class="table_sectiontitle">
        <td colspan="2">
          {{label}}
        </td>
      </tr>
    }
    @for (e of positions; track e; let i = $index; let last = $last) {
      <tr>
        <th>#</th>
        <td>
          {{i + 1}}
        </td>
      </tr>
      <tr>
        <th>
          <view-field-label-render [mode]="'table'" fieldname="bezeichnung"></view-field-label-render>
        </th>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="bezeichnung"></view-field-value-render>
        </td>
      </tr>
      <tr>
        <th>Kategorie</th>
        <td>
          {{parent.getViewLabelBySlug(e.view_slug)}}
        </td>
      </tr>
      <tr>
        <th>
          <view-field-label-render [mode]="'table'" fieldname="pzn"></view-field-label-render>
        </th>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'" fieldname="pzn"></view-field-value-render>
        </td>
      </tr>
      <tr>
        <th>
          <view-field-label-render [mode]="'table'" fieldname="darreichungsform"></view-field-label-render>
        </th>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="darreichungsform"></view-field-value-render>
        </td>
      </tr>
      <tr>
        <th>
          <view-field-label-render [mode]="'table'" fieldname="rezeptzeichen"></view-field-label-render>
        </th>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="rezeptzeichen"></view-field-value-render>
        </td>
      </tr>
      <tr>
        <th>
          <view-field-label-render [mode]="'table'" fieldname="istarzneimittel"></view-field-label-render>
        </th>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="istarzneimittel"></view-field-value-render>
        </td>
      </tr>
      <tr>
        <th>Einzelpreis</th>
        <td>
          <view-field-value-render [artikel]="e.artikel" [mode]="'table'"
          fieldname="einkaufspreis"></view-field-value-render>
        </td>
      </tr>
      <tr>
        <td>
          <div style="width: 20px; height: 20px">
            @if (e.dirty) {
              <div matTooltip="Speichere...">
                <mat-spinner [diameter]="20"></mat-spinner>
              </div>
            }
          </div>
        </td>
        <td>
          <nice-number-input [(value)]="positions[i].menge" [disabled]="e.defect"></nice-number-input>
          <warenkorb-button [artikel]="e.artikel" [entry]="e" [view_slug]="e.view_slug" [disabled]="e.defect"
          class="tut_merkliste_artwk"></warenkorb-button>
          <button (click)="parent.addNoteLine(e)" [disabled]="e.defect" mat-icon-button matTooltip="Notiz hinzufügen" class="tut_merkliste_artnote">
            <svg-icon>zeile-einfuegen</svg-icon>
          </button>
          <button (click)="parent.deletePosition(e)" mat-icon-button matTooltip="Position Entfernen" class="tut_merkliste_artdelete">
            <svg-icon>loeschen</svg-icon>
          </button>
          <verfuegbarkeits-info-button [artikel]="e.artikel" [entry]="e" class="tut_merkliste_artvf"
          [view_slug]="e.view_slug"></verfuegbarkeits-info-button>
        </td>
      </tr>
      @for (line of e.note; track parent.trackByFn(i, line); let i = $index) {
        <tr>
          <td colspan="2">
            <table style="width: 100%">
              <tr>
                <td>
                  <mat-form-field style="width: 100%">
                    <input (keyup)="parent.noteAutoSave(e)" [(ngModel)]="e.note[i]" matInput maxlength="80"
                      placeholder="Notiz {{i+1}}">
                    <mat-hint>Maximal 80 Zeichen!</mat-hint>
                  </mat-form-field>
                </td>
                <td>
                  <button (click)="parent.deleteNoteLine(e, i)" mat-icon-button matTooltip="Abbrechen">
                    <svg-icon>abbrechen</svg-icon>
                  </button>
                </tr>
              </table>
            </td>
          </tr>
        }
        @if (!last) {
          <tr>
            <td colspan="2" style="background-color: grey; height: 10px"></td>
          </tr>
        }
      }
      @if (poscount <= 0) {
        <tr>
          <td style="text-align: center; background-color: white; padding-top: 40px">
            <div style="vertical-align: middle">
              <svg-icon style="width: 100px; height: 100px; font-size: 100px">traurig</svg-icon>
              <br>
                <div style="height: 100px; font-size: 16px; font-weight: bold">
                  @if (poscount == -1) {
                    Lade die Merkliste...
                    <div style="text-align: center">
                      <div style="display: inline-block; width: 20px; height: 20px">
                        <mat-spinner [diameter]="20"></mat-spinner>
                      </div>
                    </div>
                  } @else {
                    Die Merkliste ist leer.
                  }
                </div>
              </div>
            </td>
          </tr>
        }
      }
